import './DividendCalendar.scss'
import React, { useEffect, useRef, useState, useLayoutEffect, useContext } from 'react'
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar'
import { Col, Row, Container } from 'react-bootstrap'

import ParallelButtonSelection from '../../../components/selections/periodSelection/parallelButtonSelection';
import { DividendApi } from "../../../services/dividend/api";
import { Configuration } from "../../../services/dividend/configuration";
import { useSelector } from "react-redux";
import moment from 'moment';

import DataTableComponent from '../../../components/dataTables/dataTable';
import { Toast } from 'primereact/toast';
import DropdownPicker from '../../../components/pickers/dropdownPicker';
import Spinner from '../../../components/spinner';
import DividendGraphs from '../../../components/charts/dividendCharts/dividendGraphs';
import { Configuration as ActionHubServisConfig, SecuritiesServiceApi } from '../../../services/actionHub'
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { set } from 'lodash';
import NumberFormatter from '../../../formatters/NumberFormatter';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
import security from '../../../stores/security';
moment.locale('tr');

export default function DividendCalendar() {
    const { t } = useTranslation();
    const toast = useRef(null);
    const numberFormatter = new NumberFormatter();
    const api = new DividendApi(new Configuration({ basePath: process.env.REACT_APP_DIVIDEND_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_DIVIDEND_API_BASE_PATH));
    const actionHubApi = new SecuritiesServiceApi(new ActionHubServisConfig({ basePath: process.env.REACT_APP_ACTIONHUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTIONHUB_API_BASE_PATH));
    const token = useSelector((state) => state.auth?.token);
    const [visible, setVisible] = useState(false);
    const [activeDividendCalenderCategory, setActiveDividendCalenderCategory] = useState(3);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [symbol, setSymbol] = useState();
    const [tableColumns, setTableColumns] = useState();
    const [absoluteSearch, setAbsoluteSearch] = useState(false);
    const [sortField, setSortField] = useState();
    const [sortOrder, setSortOrder] = useState(-1);
    const [pastDividendSelectedSecurity, setPastDividendSelectedSecurity] = useState();
    const [pastDividendSecurities, setPastDividendSecurities] = useState([]);
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);

    const handleClose = () => setVisible(false);

    const didivdenCalendarListTitles = [
        {
            id: 1,
            name: t('dividend.dividendCalendar.categories.explained'),
        },
        {
            id: 2,
            name: t('dividend.dividendCalendar.categories.dateUncertain'),

        },
        {
            id: 3,
            name: t('dividend.dividendCalendar.categories.dividendHistory'),
        }
    ]

    const months = [
        { code: "All", name: t('allMonthsTable'), id: 0 },
        { code: "January", name: t('date.months.january'), id: 1 },
        { code: "February", name: t('date.months.february'), id: 2 },
        { code: "March", name: t('date.months.march'), id: 3 },
        { code: "April", name: t('date.months.april'), id: 4 },
        { code: "May", name: t('date.months.may'), id: 5 },
        { code: "June", name: t('date.months.june'), id: 6 },
        { code: "July", name: t('date.months.july'), id: 7 },
        { code: "August", name: t('date.months.august'), id: 8 },
        { code: "September", name: t('date.months.september'), id: 9 },
        { code: "October", name: t('date.months.october'), id: 10 },
        { code: "November", name: t('date.months.november'), id: 11 },
        { code: "December", name: t('date.months.december'), id: 12 },
    ]

    const columnsAll_new = [
        { id: 0, field: 'dividendCalendarPaymentDate', displayName: 'Favoriler', isFrozen: true, isVisible: true, align: 'left', width: '2%', paddingRight: '5px', sortable: false },
        { id: 1, field: 'searchableHeader', displayName: 'Sembol', header: t('tableHeader.symbol'), filterField: "code", isFrozen: true, format: "code-s-f-m-i", isVisible: true, align: 'left', width: '1%', paddingRight: '0px', sortable: false },
        { id: 5, field: 'netDividendPerShare', displayName: 'Hisse Başı Net T. (TL)', header: t('tableHeader.netDividendPerShare') + '(TL)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 6, field: 'dividendYieldTTM', displayName: 'Temettü Verimi (%)', header: t('tableHeader.dividendYield-2') + ' (%)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 7, field: 'threeYearAverageDividendYield', displayName: '3 yıllık Ort. T. Veri. (%)', header: t('tableHeader.threeYearAverageDividendYield') + '(%)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 8, field: 'threeYearDividendCAGR', displayName: '3 Yıllık T. Büyü. (%)', header: t('tableHeader.threeYearDividendCAGR') + '  (%)', isVisible: true, align: 'right', width: '10%', clikable: false, sortable: true },
        { id: 9, field: 'threeYearRatioCAGR', displayName: '3 Yıllık Net Kar B. (%)', header: t('tableHeader.threeYearRatioCAGR') + '  (%)', isVisible: true, align: 'right', width: '10%', clikable: false, sortable: true },
        { id: 10, field: 'threeYearAvaregeProfitDistributeRatio', displayName: '3 Yıllık Ort. Kar Dağ. Or.', header: t('tableHeader.threeYearAvaregeProfitDistributeRatio'), isVisible: true, align: 'right', width: '11%', clikable: false, sortable: true },
        { id: 11, field: 'pddd', displayName: 'PD/DD', header: t('tableHeader.pddd'), isVisible: true, align: 'right', width: '8% ', clikable: false, sortable: true },
        { id: 12, field: 'fk', displayName: 'F/K', header: t('tableHeader.p-e'), isVisible: true, align: 'right', width: '8% ', clikable: false, sortable: true },
        { id: 13, field: 'ybgYield', displayName: 'YBG Getiri (%)', header: t('tableHeader.ybgYield') + '  (%)', isVisible: true, align: 'right', width: '12% ', clikable: false, sortable: true },
        { id: 14, field: 'yearlyYield', displayName: 'Yıllık Getiri (%)', header: t('tableHeader.yearlyYield') + '  (%)', isVisible: true, align: 'right', width: '12% ', clikable: false, sortable: true },

    ];


    const indefiniteDateTableColumns = [
        { id: 1, field: 'searchableHeader', displayName: 'Sembol', header: 'Sembol', filterField: "code", isFrozen: true, format: "code-s-f-t-i", isVisible: true, align: 'left', width: '1%', paddingRight: '0px', sortable: false },
        { id: 5, field: 'netDividendPerShare', displayName: 'Hisse Başı Net T. (TL)', header: t('tableHeader.netDividendPerShare') + '  (TL)', isVisible: true, align: 'right', width: '11%', clikable: false, sortable: true },
        { id: 6, field: 'dividendYieldTTM', displayName: 'Temettü Verimi (%)', header: t('tableHeader.dividendYield-2') + ' (%)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 7, field: 'threeYearAverageDividendYield', displayName: '3 yıllık Ort. T. Veri. (%)', header: t('tableHeader.threeYearAverageDividendYield') + '(%)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 8, field: 'threeYearDividendCAGR', displayName: '3 Yıllık T. Büyü. (%)', header: t('tableHeader.threeYearDividendCAGR') + '  (%)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 9, field: 'threeYearRatioCAGR', displayName: '3 Yıllık Net Kar B. (%)', header: t('tableHeader.threeYearRatioCAGR') + '  (%)', isVisible: true, align: 'right', width: '9%', clikable: false, sortable: true },
        { id: 10, field: 'threeYearAvaregeProfitDistributeRatio', displayName: '3 Yıllık Ort. Kar Dağ. Or.', header: t('tableHeader.threeYearAvaregeProfitDistributeRatio'), isVisible: true, align: 'right', width: '11%', clikable: false, sortable: true },
        { id: 11, field: 'pddd', displayName: 'PD/DD', header: t('tableHeader.pddd'), isVisible: true, align: 'right', width: '5% ', clikable: false, sortable: true },
        { id: 12, field: 'fk', displayName: 'F/K', header: t('tableHeader.p-e'), isVisible: true, align: 'right', width: '5% ', clikable: false, sortable: true },
        { id: 13, field: 'ybgYield', displayName: 'YBG Getiri (%)', header: t('tableHeader.ybgYield') + '  (%)', isVisible: true, align: 'right', width: '5% ', clikable: false, sortable: true },
        { id: 14, field: 'yearlyYield', displayName: 'Yıllık Getiri (%)', header: t('tableHeader.yearlyYield') + '  (%)', isVisible: true, align: 'right', width: '1% ', clikable: false, sortable: true }
    ];

    const pastDividendTableColumns = [
        // { id: 1, field: 'fav', displayName: 'Favoriler', header: '', isVisible: true, align: 'left', width: '1%', paddingRight: '0px', sortable: false },
        // { id: 2, field: 'code', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'left', width: '5%', clikable: true, paddingRight: '0px', sortable: false },
        // { id: 3, field: 'technicalAnalysis', displayName: 'Teknik Analiz', header: '', width: '1%', isVisible: true, paddingRight: '0px', sortable: false },
        // { id: 4, field: 'dividendExpectChart', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'center', width: '3%', clikable: false, paddingRight: '0px', paddingLeft: '0px', sortable: false },
        { id: 5, field: 'paymentDate', displayName: 'Ödeme Tarihi', header: t('tableHeader.paymentDate'), isVisible: true, align: 'center', clikable: false, sortable: true },
        { id: 6, field: 'netDividend', displayName: 'Hisse Başı Net Tutar (TL)', header: t('tableHeader.netAmountPerShare') + ' (TL)', isVisible: true, align: 'right', clikable: false, sortable: true },
        { id: 7, field: 'dividendYield', displayName: 'Temettü Verimi (%)', header: t('tableHeader.dividendYield-2') + ' (%)', isVisible: true, align: 'right', clikable: false, sortable: true },
        { id: 8, field: 'threeYearRatioCAGR', displayName: 'Temettü Yıllık Büyümesi Oranı (%)', header: t('tableHeader.dividendAnnualGrowthRate') + ' (%)', isVisible: true, align: 'right', clikable: false, sortable: true },
        { id: 9, field: 'distributeRatio', displayName: 'Yıllık Kar Dağıtma Oranı (%)', header: t('tableHeader.annualProfitDistributionRate') + ' (%)', isVisible: true, align: 'right', clikable: false, sortable: true },

    ]

    useEffect(() => {
        // Start with loading state active
        setIsLoading(true);
        
        // Initialize component state
        setAbsoluteSearch(false);
        setSortField('dividendYieldTTM');
        setTableColumns(columnsAll_new);
        
        // Set initial category (which will trigger its useEffect and data loading)
        setActiveDividendCalenderCategory(didivdenCalendarListTitles[0]);
        
        // Set initial month selection - 'Tümü' as specified by HLY-I158
        setSelectedMonth(months.find((item) => item.id == 0));
        
        // Note: The API calls will be triggered by the activeDividendCalenderCategory useEffect
        // Loading state will be managed by the API call chain
    }, []);

    useEffect(() => {
        if (selectedMonth !== undefined && selectedMonth !== null) {
            // Only call getDividendDeclared if activeDividendCalenderCategory.id is 1
            // This prevents unnecessary API calls when switching categories
            if (activeDividendCalenderCategory && activeDividendCalenderCategory.id === 1) {
                setIsLoading(true); // Show loading state when month changes
                setTableData([]); // Clear table data to avoid showing stale data
                getDividendDeclared();
            }
        }
    }, [selectedMonth, activeDividendCalenderCategory]);

    useEffect(() => {
        // Set loading state to true at the beginning of any category change
        setIsLoading(true);
        
        // Clear table data to avoid showing stale data during loading
        setTableData([]);
        
        if (activeDividendCalenderCategory.id === 1) {
            setTableColumns(columnsAll_new);
            setAbsoluteSearch(false);
            setSortField('paymentDateTime');
            setSortOrder(1);
            // Call API to load data for this category
            getDividendDeclared();
        }
        else if (activeDividendCalenderCategory.id === 2) {
            setTableColumns(indefiniteDateTableColumns);
            setAbsoluteSearch(true);
            setSortField('dividendYieldTTM');
            // Call API to load data for this category
            getIndefiniteDate();
        }
        else if (activeDividendCalenderCategory.id === 3) {
            setTableColumns(pastDividendTableColumns);
            setAbsoluteSearch(false);
            setSortField('paymentDateTime');
            // Call API to load data for this category
            populateDividendSecurities();
            // Loading will be handled by the chain of API calls
        }
    }, [activeDividendCalenderCategory]);

    useEffect(() => {
        if (pastDividendSecurities.length > 0) {
            // Keep loading state active until we set a selected security
            setIsLoading(true);

            let defaultSecurity = pastDividendSecurities.find((item) => item.code === 'EREGL');

            if (defaultSecurity) {
                setPastDividendSelectedSecurity(defaultSecurity);
            } else {
                setPastDividendSelectedSecurity(pastDividendSecurities[0]);
            }
        }
    }, [pastDividendSecurities]);

    useEffect(() => {
        if (pastDividendSelectedSecurity !== undefined && pastDividendSelectedSecurity !== null) {
            getPastDividend();
        }
    }, [pastDividendSelectedSecurity]);

    const populateDividendSecurities = () => {
        try {
            // Loading is already set to true by the category change useEffect
            actionHubApi.actionhubSecuritiesGet(token).then((res) => {
                console.log('populateDividendSecurities res: ', res);
                if (res.data.error && res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                    setIsLoading(false); // Set loading to false on error
                    setTableData([]); // Clear table data on error
                }
                else {
                    // Don't set loading to false here - wait until pastDividendSelectedSecurity is set and getPastDividend completes
                    if (!res.data.securities || res.data.securities.length === 0) {
                        // If no securities are returned, set loading to false and clear the table
                        setIsLoading(false);
                        setTableData([]);
                    } else {
                        // Otherwise, update the securities list which will trigger the next useEffect chain
                        setPastDividendSecurities(res.data.securities);
                        // Loading will continue to be true until getPastDividend completes
                    }
                }
            }).catch((err) => {
                // console.log(err);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Bir hata oluştu. service error', life: 3000 });
                setIsLoading(false);
                setTableData([]);
            });
        }
        catch (error) {
            console.log('populateDividendSecurities error: ', error);
            setIsLoading(false); // Set loading to false on error
            setTableData([]); // Clear table data on error
        }
    }

    //#region ParallelButtonSelection Props

    const clicDividendCalendarCategory = (item) => {
        // Show loading immediately when category changes
        setIsLoading(true);
        // Clear table data to avoid showing stale data
        setTableData([]);
        // Then update the category which will trigger the useEffect
        setActiveDividendCalenderCategory(item);
    }

    //#endregion ParallelButtonSelection Props


    //#region  DataTable Props 

    const dividendCalendarChangeMonth = (item) => {
        // Show loading immediately when month changes
        setIsLoading(true);
        // Clear table data to avoid showing stale data
        setTableData([]);
        // Then update the month which will trigger the useEffect
        setSelectedMonth(item);
        console.log('dividendCalendarSelectedMonth: ', item);
    }

    //#endregion DataTable Props


    //#region DataTable Dividend Graph Modal
    const openDividendGrapshModal = (item) => {

        try {
            if (item === undefined || item === null) {
                return;
            }
            setVisible(true);
            setSymbol(item);
        } catch (error) {
            console.log('openDividendGrapshModal error: ', error);
        }
    }

    //#endregion DataTable Dividend Graph Modal

    //#region API CALLS

    const getDividendDeclared = () => {
        try {
            // Loading is already set to true by the category change useEffect
            api.apiDividendDeclaredGet(token, selectedMonth.code).then((res) => {
                if (res.data.error && res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                    setIsLoading(false); // Set loading to false on error
                    setTableData([]); // Clear table data on error
                }
                else {
                    let data = res.data.map((item) => {
                        return {
                            code: item.equity,
                            paymentDateTime: item.paymentDate,
                            netDividendPerShare: !item.netDividendPerShare ? item.netDividendPerShare = null : numberFormatter.formatMoney(item.netDividendPerShare, 2),
                            dividendYieldTTM: !item.dividendYieldTTM ? item.dividendYieldTTM = null : parseFloat(item.dividendYieldTTM).toFixed(2),
                            threeYearDividendCAGR: !item.threeYearDividendCAGR ? item.threeYearDividendCAGR = null : parseFloat(item.threeYearDividendCAGR).toFixed(2),
                            threeYearRatioCAGR: !item.threeYearRatioCAGR ? item.threeYearRatioCAGR = null : parseFloat(item.threeYearRatioCAGR).toFixed(2),
                            threeYearAverageDividendYield: !item.threeYearAverageDividendYield ? item.threeYearAverageDividendYield = null : parseFloat(item.threeYearAverageDividendYield).toFixed(2),
                            threeYearAvaregeProfitDistributeRatio: !item.threeYearAvaregeProfitDistributeRatio ? item.threeYearAvaregeProfitDistributeRatio = null : parseFloat(item.threeYearAvaregeProfitDistributeRatio).toFixed(2),
                            pddd: !item.pddd ? item.pddd = null : parseFloat(item.pddd).toFixed(2),
                            fk: !item.fk ? item.fk = null : parseFloat(item.fk).toFixed(2),
                            ybgYield: !item.ybgYield ? item.ybgYield = null : parseFloat(item.ybgYield).toFixed(2),
                            yearlyYield: !item.yearlyYield ? item.yearlyYield = null : parseFloat(item.yearlyYield).toFixed(2),
                            entityId: item.entityId,
                            // Updated to handle both numberOfInstallments and installement fields
                            numberOfInstallments: item.numberOfInstallments !== undefined ? 
                                item.numberOfInstallments : 
                                (item.installement !== undefined ? item.installement : null),
                        }
                    });

                    data.sort((a, b) => { return new Date(a.paymentDateTime) - new Date(b.paymentDateTime) });

                    // Set table data first, then update loading state
                    setTableData(data);
                    setIsLoading(false);
                }
            }).catch((err) => {
                // console.log(err);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Bir hata oluştu. service error', life: 3000 });
                setIsLoading(false);
                setTableData([]);
            });

        } catch (error) {
            console.log('getDividendDeclared error: ', error);
            setIsLoading(false); // Set loading to false on error
            setTableData([]); // Clear table data on error
        }
    }


    const getIndefiniteDate = () => {
        try {
            // Loading is already set to true by the category change useEffect
            const securityCode = '';
            // Remove debugger statements
            
            api.apiDividendIndefinitedateGet(token, securityCode).then((res) => {
                if (res.data.error && res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                    setIsLoading(false); // Set loading to false on error
                    setTableData([]); // Clear table data on error
                }
                else {
                    let data = res.data.map((item) => {
                        return {
                            code: item.equity,
                            dividendCalendarPaymentDate: moment(item.paymentDate).format('DD MMMM'),
                            netDividendPerShare: !item.netDividendPerShare ? item.netDividendPerShare = null : parseFloat(item.netDividendPerShare),
                            dividendYieldTTM: !item.dividendYieldTTM ? item.dividendYieldTTM = null : parseFloat(item.dividendYieldTTM).toFixed(2),
                            threeYearDividendCAGR: !item.threeYearDividendCAGR ? item.threeYearDividendCAGR = null : parseFloat(item.threeYearDividendCAGR).toFixed(2),
                            threeYearRatioCAGR: !item.threeYearRatioCAGR ? item.threeYearRatioCAGR = null : parseFloat(item.threeYearRatioCAGR).toFixed(2),
                            threeYearAverageDividendYield: !item.threeYearAverageDividendYield ? item.threeYearAverageDividendYield = null : parseFloat(item.threeYearAverageDividendYield).toFixed(2),
                            threeYearAvaregeProfitDistributeRatio: !item.threeYearAvaregeProfitDistributeRatio ? item.threeYearAvaregeProfitDistributeRatio = null : parseFloat(item.threeYearAvaregeProfitDistributeRatio).toFixed(2),
                            pddd: !item.pddd ? item.pddd = null : parseFloat(item.pddd).toFixed(2),
                            fk: !item.fk ? item.fk = null : parseFloat(item.fk).toFixed(2),
                            ybgYield: !item.ybgYield ? item.ybgYield = null : parseFloat(item.ybgYield).toFixed(2),
                            yearlyYield: !item.yearlyYield ? item.yearlyYield = null : parseFloat(item.yearlyYield).toFixed(2),
                            entityId: item.entityId,
                            numberOfInstallments: item.numberOfInstallments !== undefined ?
                                item.numberOfInstallments :
                                (item.installement !== undefined ? item.installement : null),
                        }
                    });

                    // Set table data first, then update loading state
                    setTableData(data);
                    setIsLoading(false);
                }
            }).catch((err) => {
                // console.log(err);
                toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Bir hata oluştu. service error', life: 3000 });
                setIsLoading(false);
                setTableData([]);
            });

        } catch (error) {
            console.log('getIndefiniteDate error: ', error);
            setIsLoading(false); // Set loading to false on error
            setTableData([]); // Clear table data on error
        }
    }

    const getPastDividend = () => {
        try {
            // setIsLoading is already true from previous steps
            // This ensures loading stays visible until data is ready

            api.apiDividendAnalysisGet(pastDividendSelectedSecurity["code"], token).then((res) => {
                if (res.data.error && res.data.error !== undefined && res.data.error !== null && res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                    setTableData([]);
                    setIsLoading(false); // Set loading to false on error
                }
                else {
                    let formattedData = [];
                    res.data.forEach((it) => {
                        let obj = {
                            paymentDate: it.paymentDate,
                            netDividend: parseFloat(it.netDividend).toFixed(2) === 'NaN' ? '' : parseFloat(it.netDividend).toFixed(2),
                            threeYearRatioCAGR: parseFloat(it.dividendCAGR).toFixed(2) === 'NaN' ? '' : parseFloat(it.dividendCAGR).toFixed(2),
                            dividendYield: parseFloat(it.dividendYieldAvg).toFixed(2) === 'NaN' ? '' : parseFloat(it.dividendYieldAvg).toFixed(2),
                            distributeRatio: parseFloat(it.yearlyPayoutRatio).toFixed(2) === 'NaN' ? '' : parseFloat(it.yearlyPayoutRatio).toFixed(2),
                        };
                        formattedData.push(obj);
                    });

                    // Finally set loading to false once we have the data
                    setIsLoading(false);
                    setTableData(formattedData);
                }

            }).catch((err) => {
                // console.log(err);
                setIsLoading(false);
                setTableData([]);
            });

        } catch (error) {
            console.log('getPastDividend error: ', error);
            setIsLoading(false); // Set loading to false on error
        }
    }




    //#region DataTable Column Template


    const bodyTemplate = (quarterIndex) => {


        if (quarterIndex == 'quarter1') {

            return (
                <div className="flex align-items-center gap- 2">
                    <DropdownPicker
                        className=''
                        listData={months}
                        selectedListItem={selectedMonth}
                        onListItemChange={(event) => onQuarterChange(0, event.name, event)}
                        optionLabel='name'
                        icon={true}
                    />
                </div>
            );
        }
    };

    const onQuarterChange = (index, name, event) => {
    }

    //#endregion DataTable Column Template



    return (

        <div className='' id='DividendCalendar'>
            <Toast ref={toast} position="bottom-right" />
            <Container>
                <Row>
                    <LiveTickerBar />
                </Row>
                <Row className='m-t-15'>
                    <h1 className='roboto-bold-24 color-text'>{t('dividend.dividendCalendar.title')}</h1>
                </Row>
            </Container>

            <Container className=''>

                <Row>
                    <Col md='10'>
                        <ParallelButtonSelection titles={didivdenCalendarListTitles} activeTitle={activeDividendCalenderCategory.id} clickTitle={clicDividendCalendarCategory} />

                    </Col>
                </Row>
                <Row>
                    <Col md='12'>
                        {isLoading && <Spinner height="600px" />}
                        {!isLoading &&
                            <div className={[`dividend-calendar-table ${activeDividendCalenderCategory.id === 3 ? 'table-header-small' : ''}`]}>
                                {activeDividendCalenderCategory.id === 3 &&
                                    (
                                        <div className='d-flex flex-wrap table-dropdown-partial'>

                                            <Dropdown
                                                value={pastDividendSelectedSecurity}
                                                onChange={(e) => setPastDividendSelectedSecurity(e.value)}
                                                options={pastDividendSecurities}
                                                optionLabel="code"
                                                placeholder="Select a Country"
                                                filter
                                                className="w-full md:w-14rem table-header-dropdown"
                                            />
                                        </div>
                                    )}
                                <DataTableComponent
                                    columnsProp={tableColumns}
                                    dataProp={tableData}
                                    columnsSelect={false}
                                    search={false}
                                    scrollHeight={'100%'}
                                    openDividendGrapshModal={openDividendGrapshModal}
                                    dividendCalendarChangeMonth={dividendCalendarChangeMonth}
                                    dividendCalendarSelectedMonth={selectedMonth}
                                    sortField={sortField}
                                    sortOrder={sortOrder}

                                />
                            </div>
                        }
                    </Col>
                </Row>
            </Container>

            <DividendGraphs modalVisible={visible} closeModal={handleClose} symbol={symbol} />

        </div >
    )
}

